const DEFAULT_REM = 16;

function pxIntoRem(pix: number) {
  return (pix / DEFAULT_REM).toFixed(3) + "rem";
}

export default pxIntoRem;
